/**
 * Check if lang is one of the locales
 * @param lang string
 * @param locales Array of strings
 */
export const isLocale = (lang: string, locales: string[]) => {
	return locales.some((l) => l === lang);
};
